import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { useAuth } from "../../components/AuthContext/AuthContext";
import { XSquare } from "react-bootstrap-icons";
import { useMediaQuery } from "react-responsive";
import { isFormDirty } from "../Forms/DynamicForm";

function NavigateButtons({ formikRef, isTimefield = false, onContinue, setShouldNavigate = () => {}, handleSubmit,submitAction }) {
  const navigate = useNavigate();
  const auth = useAuth();
  const location = useLocation();
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const triggerFormSubmit = async () => {
    if (formikRef?.current) {
      await formikRef.current.submitForm();
      return;
    }
    const form = document.getElementById("dynamic-form");
    if (form) {
      form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
    }
  };

  const triggerContinueCallbacks = () => {
    if (onContinue) onContinue();
    setShouldNavigate(true);
  };

const handleConfirmDetailsContinue = async () => {
  if (!formikRef?.current) return;

  const { validateForm, setTouched, values } = formikRef.current;

  if (isFormDirty(formikRef.current)) {
    auth?.showToast(
      "Save The Changes",
      "Please save the changes",
      "../assets/mhc.png",
      <XSquare />,
    );
    return;
  }

  const errors = await validateForm();
  if (Object.keys(errors).length > 0) {
    setTouched(
      Object.keys(errors).reduce((acc, key) => {
        acc[key] = true;
        return acc;
      }, {})
    );
    return;
  }

  const isSubmit = await handleSubmit(values, true, true);

  // Only navigate if handleSubmit did NOT block (gender warning returns false)
  if (isSubmit === false) {
    setShouldNavigate(false);
    return; // <-- stop here, do not call triggerContinueCallbacks
  }

  triggerContinueCallbacks();
};

  const handleDefaultContinue = async () => {
    await triggerFormSubmit();
    triggerContinueCallbacks();
  };

  const handleContinue = () => {
    const isConfirmDetailsPage = location.pathname.includes("confirm-details");

    if (isConfirmDetailsPage) {
      submitAction.current = "continue";
      handleConfirmDetailsContinue();
    } else {
      handleDefaultContinue();
    }
  };

  const handlePrevious = () => {
    navigate(-1);
  };

  return (
    <div className={`my-4 mx-auto row d-flex justify-content-between g-2 navigate-buttons ${isMobile && "flex-column-reverse"}`}>
      <button
        type="button"
        onClick={handlePrevious}
        className="btn btn-white col-12 col-md-2 col-lg-2 col-xl-2 me-3 ageo-semibold btn-layout "
      >
        Previous step
      </button>
      <button
        type="button"
        onClick={handleContinue}
        value="continue"
        className="btn btn-primary col-12 col-md-2 col-lg-2 col-xl-2 ageo-semibold btn-layout"
      >
        {isTimefield ? "Confirm & Continue" : "Continue"}
      </button>
    </div>
  );
}

NavigateButtons.propTypes = {
  formikRef: PropTypes.shape({
    current: PropTypes.shape({
      submitForm: PropTypes.func,
      dirty: PropTypes.bool,
      values: PropTypes.object,
      validateForm: PropTypes.func,
      setTouched: PropTypes.func,
    }),
  }),
  onContinue: PropTypes.func,
  setShouldNavigate: PropTypes.func,
  handleSubmit: PropTypes.func,
  submitAction: PropTypes.shape({
    current: PropTypes.string,
  }).isRequired,
};

export default NavigateButtons;